import { useCallback } from "react";
import { useSelector } from "react-redux";
import { trackDashboardCtaClicked } from "analytics";
import { selectExistingOrdersWithoutCancelled } from "store/reducers/order/OrderInformationSlice";
import { Kit } from "types/kit";
import NextMoveCard from ".";
import { SHOW_ALL_NEXT_MOVE_CARDS } from "./showAllNextMoveCards";
import Translate from "translate/Translate";

const NAVIGATION_EMAIL = "navigation@genomiclife.com";

const TestingInProgressNextMoveCard = () => {
  const kitOrders = useSelector(selectExistingOrdersWithoutCancelled);
  const ordersForKitsThatAreSubmittedButNotCompleteYet = kitOrders.filter(
    (order: Kit) => order.documentIds?.length === 0
  );
  const hasOrdersInProgress =
    ordersForKitsThatAreSubmittedButNotCompleteYet.length > 0;

  const onActionClick = useCallback(() => {
    trackDashboardCtaClicked({
      workflow: "kit_order",
      ctaLocation: "next_move_card",
      ctaId: "testing_in_progress"
    });
  }, []);

  if (!SHOW_ALL_NEXT_MOVE_CARDS && !hasOrdersInProgress) {
    return null;
  }

  return (
    <NextMoveCard
      id="testing-in-progress-next-move"
      tag="inProgress"
      title={<Translate text="Testing in progress" />}
      body={
        <Translate text="You will receive a collection kit in the mail; follow the included instructions for collection and returning the kit. Results will be ready 2-3 weeks after the laboratory receives your sample." />
      }
      subBody={
        <Translate
          text={`If you have trouble with sample collection, simply send us an email at ${NAVIGATION_EMAIL}`}
        />
      }
      link={{
        onClick: onActionClick,
        url: `mailto:${NAVIGATION_EMAIL}`
      }}
    />
  );
};

export default TestingInProgressNextMoveCard;
